import { isWindowDefined } from "@src/helpers/url";

const viewportDimensions = () => {
  if (!isWindowDefined() || !window.innerWidth || !window.innerHeight) {
    return "";
  }
  return `${window.innerWidth}:${window.innerHeight}`;
};

export default viewportDimensions;
